export let Action = /*#__PURE__*/function (Action) {
  Action["Click"] = "Click";
  Action["View"] = "View";
  return Action;
}({});
export let Feature = /*#__PURE__*/function (Feature) {
  Feature["TransferMoney"] = "Transfer Money";
  return Feature;
}({});
export let SubFeature = /*#__PURE__*/function (SubFeature) {
  SubFeature["ExternalTransfer"] = "External Transfer";
  SubFeature["InternalTransfer"] = "Internal Transfer";
  return SubFeature;
}({});
export let Page = /*#__PURE__*/function (Page) {
  Page["Homepage"] = "Homepage";
  Page["TransferSpeed"] = "Transfer Speed";
  return Page;
}({});
export let Target = /*#__PURE__*/function (Target) {
  Target["Transfer"] = "Transfer";
  Target["GoToBillPay"] = "Go To Bill Pay";
  return Target;
}({});
export let Applet = /*#__PURE__*/function (Applet) {
  Applet["Balance"] = "Balance";
  Applet["Homepage"] = "Homepage";
  Applet["TransferSettings"] = "Transfer Settings";
  return Applet;
}({});
const getEventName = (action, feature) => `${action} ${feature}`;
export function getEvent(action, args) {
  const feature = Feature.TransferMoney;
  return {
    name: getEventName(action, feature),
    properties: {
      feature,
      ...args
    }
  };
}